export interface ProjectDocument {
  fileType?: string
  fileName?: string
  _id?: string
  projectId?: string
  section?: string
  url?: string
  title?: string
  description?: string

  /**
   * Back-office "Downloadable while not logged in". Drives both the access badge and
   * which endpoint the download uses. Defaults to false, i.e. gated.
   */
  publiclyDownloadable?: boolean
  /** Back-office visibility toggle for the STO details page. */
  showOnSTOPage?: boolean
  /** Audience scope (all investors vs a specific tranche) — not the login gate. */
  onlyInvestors?: boolean
  isPrivateSaleDoc?: boolean
  isPublicSaleDoc?: boolean
  isTemplate?: boolean
  templateId?: string
  investmentId?: string
  countries?: string[]
  tranches?: string[]
  tooltip?: string
  /** ISO timestamps. */
  createdAt?: string
  updatedAt?: string
}

export const normalizeProjectDocuments = (
  documents: readonly ProjectDocument[] | null | undefined,
  projectName: string,
): ProjectDocument[] => {
  if (!Array.isArray(documents)) return []

  return documents.map((doc) => {
    if (doc.fileType !== 'terms-conditions') return { ...doc }

    const correctDocName = `Terms_and_conditions_${projectName}`
    return {
      ...doc,
      fileName: `${(doc.fileName ?? '').slice(0, correctDocName.length)}.pdf`,
    }
  })
}
